/**
 * @generated SignedSource<<ab48ca5ed87a267e1fe6272e70b4ef3c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type RewardKind = "CrmTreeHeadUpdater" | "ExternalLicense" | "GamificationPoints" | "IHKCertificate" | "IHKCertificateBundle" | "LearnStreak";
import { FragmentRefs } from "relay-runtime";
export type rewardEditor_TreeNodeFragment$data = {
  readonly id: string;
  readonly typeDefinition: {
    readonly rewards?: ReadonlyArray<{
      readonly data?: {
        readonly pool: {
          readonly data: {
            readonly name: string;
          };
        } | null;
      };
      readonly id: string;
      readonly kind: RewardKind;
      readonly " $fragmentSpreads": FragmentRefs<"rewardForm_RewardFragment">;
    }>;
  };
  readonly " $fragmentSpreads": FragmentRefs<"createExternalLicenseRewardButton_TreeNodeFragment" | "createIhkCertificateRewardBundleButton_TreeNodeFragment" | "createIhkCertificateRewardButton_TreeNodeFragment" | "rewardForm_TreeNodeFragment">;
  readonly " $fragmentType": "rewardEditor_TreeNodeFragment";
};
export type rewardEditor_TreeNodeFragment$key = {
  readonly " $data"?: rewardEditor_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"rewardEditor_TreeNodeFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "rewardEditor_TreeNodeFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "typeDefinition",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "rewards",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "kind",
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ExternalLicenseRewardData",
                      "kind": "LinkedField",
                      "name": "data",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ExternalLicensePool",
                          "kind": "LinkedField",
                          "name": "pool",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "ExternalLicensePoolData",
                              "kind": "LinkedField",
                              "name": "data",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "name",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "ExternalLicenseReward",
                  "abstractKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "rewardForm_RewardFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "type": "ContentTypeDefinition",
          "abstractKey": "__isContentTypeDefinition"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "rewardForm_TreeNodeFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "createExternalLicenseRewardButton_TreeNodeFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "createIhkCertificateRewardButton_TreeNodeFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "createIhkCertificateRewardBundleButton_TreeNodeFragment"
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};
})();

(node as any).hash = "01728044218f2ddbc0603ee0d3563cc2";

export default node;
